"use client"
import ButtonPill from "@/app/(site)/_components/Molecules/ButtonPill"
import {
    type ProductData,
    type RelatedVariant
} from "@/lib/content-service/types/ContentServiceProduct"
import { convertSnakeCaseToUpperCase } from "@/lib/utils"
import {
    type CheckoutAPIProduct,
    type RelatedProduct
} from "@/types/centra/checkout-api/products/post-products"

type FitTypeProps = {
    relatedVariantsFitType: string[]
    relatedVariants: (
        | CheckoutAPIProduct
        | RelatedProduct
        | ProductData
        | RelatedVariant
    )[]
    fitType: string
    setFitType: (fitType: string) => void
    setFilteredAllProducts: (
        products: (CheckoutAPIProduct | RelatedProduct | RelatedVariant)[]
    ) => void
}

export default function FitType({
    relatedVariantsFitType,
    relatedVariants,
    fitType,
    setFitType,
    setFilteredAllProducts
}: FitTypeProps) {
    return (
        <div
            className="mb-16 flex gap-8 border-b border-b-main-medium-grey pb-32"
            aria-label="Fit type selection"
        >
            {relatedVariantsFitType.map((mappedFitType, index) => {
                return (
                    <ButtonPill
                        key={index}
                        color="black"
                        size="small"
                        variant="secondary"
                        aria-label={convertSnakeCaseToUpperCase(mappedFitType || "")}
                        onClick={e => {
                            e.preventDefault()
                            setFilteredAllProducts(
                                relatedVariants.filter(
                                    relatedProduct =>
                                        relatedProduct?.fit_type_fit_type ===
                                        mappedFitType
                                )
                            )
                            setFitType(mappedFitType)
                        }}
                        className={`${convertSnakeCaseToUpperCase(mappedFitType || "") === convertSnakeCaseToUpperCase(fitType) ? "border-main-black" : "border-main-medium-grey"}`}
                    >
                        {convertSnakeCaseToUpperCase(mappedFitType || "")}
                    </ButtonPill>
                )
            })}
        </div>
    )
}
